// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
require('./fonts/ss-gizmo/ss-gizmo.css');

require('./scss/_base.scss');

const deps = ['bench.config.app', require('ui/common/base').name];

module.exports = angular.module('bench.ui.webBase', deps);
